module.exports = __webpack_public_path__ + "img/sample-logo4.bfdca348.png";